export const SUBMISSION_READINESS_TEST_IDS = {
  PANEL: 'submission-readiness-panel',
  READY: 'submission-readiness-ready',
  MISSING: 'submission-readiness-missing',
  CATEGORY: 'submission-readiness-category',
  ITEM: 'submission-readiness-item',
};

export const SUBMISSION_READINESS_COPY = {
  READY_TITLE: 'File looks complete for submission',
  READY_SUBTITLE: 'All submission requirements are satisfied for this file.',
  MISSING_TITLE: 'Before underwriting, this file still needs:',
};

export const UNCATEGORIZED_LABEL = 'Other';
